/**
 * PageBreadcrumb — shared breadcrumb using shadcn/ui Breadcrumb + TanStack Router Link
 */
import { Link } from "@tanstack/react-router";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@ui/components/ui/breadcrumb";

export interface BreadcrumbSegment {
  /** Display label */
  label: string;
  /** Route path — omit for the current (last) page */
  to?: string;
  /** Route params forwarded to <Link> */
  params?: Record<string, string>;
}

interface PageBreadcrumbProps {
  segments: Array<BreadcrumbSegment>;
  className?: string;
}

export function PageBreadcrumb({
  segments,
  className,
}: Readonly<PageBreadcrumbProps>) {
  return (
    <Breadcrumb className={className}>
      <BreadcrumbList>
        {segments.map((segment, index) => {
          const isLast = index === segments.length - 1;

          return (
            <BreadcrumbItem key={`${segment.label}-${index}`}>
              {index > 0 && <BreadcrumbSeparator />}
              {isLast || !segment.to ? (
                <BreadcrumbPage>{segment.label}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <Link to={segment.to} params={segment.params ?? {}}>
                    {segment.label}
                  </Link>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
